import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { getCompaniesApi } from '../api/requester'

export const useCompanies = (query, questionnaireType, timming = 300) => {
  const [data, setData] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const getCompanies = useCallback(
    debounce(async (q) => {
      if (q === '') {
        setData([])
        return
      }
      setLoading(true)
      try {
        const res = await getCompaniesApi({ q, questionnaireType })
        setData(res.data.companies)
      } catch (error) {
        console.error('Error fetching companies:', error)
        setError(error)
      } finally {
        setLoading(false)
      }
    }, timming),
    [timming, questionnaireType]
  )

  useEffect(() => {
    getCompanies(query)
  }, [query, getCompanies])

  return {
    data,
    loading,
    error,
  }
}
